const washingMachineRepairService = {
  title: "Washing Machine Repair",
  icon: "🫧",
  rateCardKey: "washing-machine",
  shortDescription:
    "Washing machine inspection, repair, installation, drainage and spin issue support.",
  longDescription:
    "Book washing machine support for repair, installation, drainage diagnosis, spin issues, vibration problems, and standard appliance check-ups.",
  consultationNote:
    "Parts replacement, motor issues, PCB faults, and drum-related breakdowns may require inspection before final pricing.",
  responsePromise:
    "Assignment depends on machine type, issue type, and technician availability.",
  warrantyPolicy:
    "Support depends on machine condition, spare part use, and repair scope.",
  subServices: [
    {
      id: "wm-inspection",
      title: "Machine Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for wash cycle issue, drainage problem, spin issue, or startup failure.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "wm-installation",
      title: "Washing Machine Installation",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic installation and connection support for semi or fully automatic machines.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "wm-uninstallation",
      title: "Washing Machine Uninstallation",
      icon: "🔁",
      group: "Installation",
      description:
        "Safe removal support for shifting, replacement, or relocation.",
      basePrice: 349,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "Visit completion only",
      unit: "job",
    },
    {
      id: "wm-drainage-repair",
      title: "Drainage / Water Outlet Issue",
      icon: "💧",
      group: "Repair",
      description:
        "Inspection and minor repair support for drainage blockage or outlet issues.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "wm-spin-issue",
      title: "Spin / Vibration Issue",
      icon: "🌀",
      group: "Repair",
      description:
        "Support for vibration, unstable spin, imbalance, or basic drum-side issue diagnosis.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default washingMachineRepairService;